"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";

import ResumeButton from "./ResumeButton";
import ThemeToggle from "./ThemeToggle";

/* Navigation Items */
const navItems = [
    { name: "Home", href: "#hero" }, // or "/"
    { name: "Projects", href: "#projects" },
    { name: "Skills", href: "#skills" },
    { name: "Designs", href: "#case-studies" },
    { name: "Contact", href: "#contact" },
];

export default function Navbar() {
    const scrollToSection = (
        e: React.MouseEvent<HTMLAnchorElement>,
        href: string
    ) => {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <motion.nav
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1], delay: 0.2 }}
            className="fixed top-6 left-1/2 -translate-x-1/2 z-50 hidden md:flex items-center gap-4"
        >
            <div className="flex items-center gap-8 bg-background/90 backdrop-blur-md border border-border rounded-full px-6 py-3 shadow-md whitespace-nowrap min-w-max">
                {/* Logo & Avatar Section */}
                <Link
                    href="#hero"
                    onClick={(e) => scrollToSection(e, "#hero")}
                    className="flex items-center gap-3 group"
                >
                    <div className="relative w-8 h-8 rounded-full overflow-hidden border border-border">
                        <Image
                            src="/avatar.png"
                            alt="Hasan avatar"
                            fill
                            className="object-cover"
                            sizes="32px"
                        />
                    </div>
                    <span className="text-sm text-text-secondary group-hover:text-foreground transition-colors">
                        Glad you&apos;re here
                    </span>
                </Link>

                {/* Divider */}
                <div className="h-6 w-px bg-border" />

                {/* Navigation Links */}
                <ul className="flex items-center gap-6">
                    {navItems.map((link) => (
                        <li key={link.name}>
                            <Link
                                href={link.href}
                                onClick={(e) => scrollToSection(e, link.href)}
                                className="text-sm text-text-secondary hover:text-accent transition-colors duration-200 relative group"
                            >
                                {link.name}
                                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-accent transition-all duration-200 group-hover:w-full" />
                            </Link>
                        </li>
                    ))}
                </ul>

                {/* Theme Toggle - Inside the pill */}
                <div className="flex items-center">
                    <div className="h-6 w-px bg-border mx-4" />
                    <ThemeToggle />
                </div>
            </div>

            {/* Split Resume Button */}
            <ResumeButton />
        </motion.nav>
    );
}
